import { Menu } from "@/types/menu"

const menuData: Menu[] = [
    {
    id: 43,
    title: "odds_screen",
    titleClosed: "Trade",
    newTab: false,
    path: "tools/trade",
    icon: "CandlestickChart",
  },
  {
    id: 32,
    title: "bet_tracker",
    titleClosed: "Tracker",
    newTab: false,
    path: "tools/tracker",
    icon: "ChartBar",
    submenu: [
      {
        id: 66,
        title: "dashboard",
        titleClosed: "Stats",
        path: "tools/tracker/dashboard",
        icon: "LayoutDashboard",
      },
      {
        id: 67,
        title: "bet_history",
        titleClosed: "History",
        newTab: false,
        path: "tools/tracker/bet-history",
        icon: "History",
      },
      {
        id: 68,
        title: "leaderboard",
        titleClosed: "Leaderboard",
        newTab: false,
        path: "tools/tracker/leaderboard",
        icon: "Trophy",
      },
      {
        id: 69,
        title: "demo",
        titleClosed: "Demo",
        newTab: false,
        path: "tools/tracker/demo",
        icon: "FlaskConical",
      },
    ],
  },
  {
    id: 3,
    title: "positive-ev",
    titleClosed: "+EV",
    newTab: false,
    path: "tools/positive-ev",
    icon: "CircleDollarSign",
  },
  {
    id: 30,
    title: "arbitrage",
    titleClosed: "Arbs",
    newTab: false,
    path: "tools/arbitrage",
    icon: "HandCoins",
  },
  {
    id: 34,
    title: "betting_education",
    titleClosed: "Blog",
    newTab: false,
    path: "blog",
    icon: "Lightbulb",
  },
  {
    id: 6,
    title: "tools",
    titleClosed: "Tools",
    newTab: false,
    icon: "Hammer",
    path: "more-tools",
    submenu: [
      {
        id: 543,
        title: "accumulator",
        titleClosed: "Acc",
        newTab: false,
        path: "more-tools/accumulator",
        icon: "Layers",
      },
      {
        id: 76,
        title: "low_holds",
        titleClosed: "Low Holds",
        newTab: false,
        path: "more-tools/low-holds",
        icon: "CircleFadingPlus",
      },
      {
        id: 76,
        title: "long_shots",
        titleClosed: "Long Shots",
        newTab: false,
        path: "more-tools/long-shots",
        icon: "LoaderPinwheel",
      },
      // {
      //   id: 68,
      //   title: "bonus_optimizer",
      //   titleClosed: "Bonus Opt",
      //   newTab: false,
      //   path: "more-tools/bonus-optimizer",
      //   icon: "Gift",
      // },
      // {
      //   id: 69,
      //   title: "free_bet_optimizer",
      //   titleClosed: "Promo Opt",
      //   newTab: false,
      //   path: "more-tools/promo-optimizer",
      //   icon: "TicketCheck",
      // },
      {
        id: 69,
        title: "ev_simulator",
        titleClosed: "Ev Sim",
        newTab: false,
        path: "more-tools/ev-simulator",
        icon: "ChartNoAxesCombined",
      }
    ],
  },
  {
    id: 5,
    title: "calculators",
    titleClosed: "Calcs",
    newTab: false,
    icon: "Calculator",
    path: "calculators",
    submenu: [
      {
        id: 51,
        title: "ev_calculator",
        titleClosed: "EV Calc",
        newTab: false,
        path: "calculators/ev-calculator",
        icon: "SquarePlus",
      },
      {
        id: 52,
        title: "arbitrage_calculator",
        titleClosed: "Arb Calc",
        newTab: false,
        path: "calculators/arb-calculator",
        icon: "CirclePlus",
      },
      {
        id: 53,
        title: "vig_calculator",
        titleClosed: "Vig Calc",
        newTab: false,
        path: "calculators/vig-calculator",
        icon: "CircleMinus",
      },
      {
        id: 55,
        title: "odds_to_probability",
        titleClosed: "Odds2Prob",
        newTab: false,
        path: "calculators/odds-to-probability-calculator",
        icon: "Percent",
      },
      {
        id: 56,
        title: "kelly_calculator",
        titleClosed: "Kelly Calc",
        newTab: false,
        path: "calculators/kelly-calculator",
        icon: "Scaling",
      },
      {
        id: 56,
        title: "risk_calculator",
        titleClosed: "Risk Calc",
        newTab: false,
        path: "calculators/risk-calculator",
        icon: "ShieldAlert",
      },
      {
        id: 57,
        title: "hedge_calculator",
        titleClosed: "Hedge Calc",
        newTab: false,
        path: "calculators/hedge-calculator",
        icon: "ShieldPlus",
      },
      {
        id: 58,
        title: "buy_odds_converter",
        titleClosed: "Buy Odds",
        newTab: false,
        path: "calculators/buy-odds-converter",
        icon: "ArrowLeftRight",
      },
      {
        id: 59,
        title: "fee_calculator",
        titleClosed: "Fees",
        newTab: false,
        path: "calculators/kalshi-polymarket-fee-calculator",
        icon: "Receipt",
      },
    ],
  },
  {
    id: 2,
    title: "docs",
    titleClosed: "Guide",
    newTab: false,
    path: "docs",
    icon: "BookOpenText",
  },
]

export default menuData
